import { createContext, useContext, useMemo, useState, type ReactNode } from 'react'
import type { CartItem, Member, Store } from './types'

type AppState = {
  member: Member | null; setMember: (member: Member | null) => void
  store: Store | null; setStore: (store: Store | null) => void
  cart: CartItem[]; add: (item: CartItem) => void; setQuantity: (id: string, quantity: number) => void; clear: () => void
}

const Context = createContext<AppState | null>(null)

export function AppProvider({ children }: { children: ReactNode }) {
  const [member, setMember] = useState<Member | null>(null)
  const [store, setStoreState] = useState<Store | null>(null)
  const [cart, setCart] = useState<CartItem[]>([])
  const setStore = (value: Store | null) => { setStoreState(value); if (value) localStorage.setItem('h5StoreId', value.id) }
  const value = useMemo<AppState>(() => ({
    member, setMember, store, setStore, cart,
    add: (item) => setCart((current) => {
      const found = current.find((x) => x.id === item.id)
      return found ? current.map((x) => x.id === item.id ? { ...x, quantity: x.quantity + 1 } : x) : [...current, { ...item, quantity: 1 }]
    }),
    setQuantity: (id, quantity) => setCart((current) => current.map((x) => x.id === id ? { ...x, quantity } : x).filter((x) => x.quantity > 0)),
    clear: () => setCart([])
  }), [member, store, cart])
  return <Context.Provider value={value}>{children}</Context.Provider>
}

export function useApp() { const value = useContext(Context); if (!value) throw new Error('AppProvider missing'); return value }
